import { Button, Container, CssBaseline, makeStyles, TextField, Typography, Input, InputAdornment, InputLabel, IconButton, FormControl, Grid, List, ListItem, Box } from '@material-ui/core';
import { COLORS } from '../../shared/Theme';

import React, { Fragment, useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import { SIcon } from '../../shared/Icon';

import axios from 'axios';
import { headadmin as v_headadmin, basic, Values, SNACKBAR_TIME } from '../../request/values';
import { useCookies } from 'react-cookie';
import { DialogDeleteClass, DialogApprove } from '../../components/Dialog';

//const SERVER = basic.server;

const useStyles = makeStyles((theme) => ({
	nanumSquare_regular: {
		fontFamily: 'NanumR',
	},
	background: {
		width: '100vw',
		height: '100vh',
		background: `url("/images/background.png")`,
	},
	content: {
		width: '100%',
		height: '100%',
		display: 'grid',
		gridTemplateColumns: '230px 1fr',
	},
	sidebar: {
		display: 'grid',
		gridTemplateRows: '60px 80px 100px 100px 100px 1fr',
		backgroundColor: `${COLORS.LIGHT_BLUE_GREY}`,
	},
	mainPage: {
		display: 'grid',
		gridTemplateRows: '60px 1fr',
	},
	title: {
		margin: 'auto 0px auto 35px',
		fontFamily: 'NanumR',
		fontSize: '1.5rem',
		fontWeight: 'bold',
		color: `${COLORS.WHITE}`,
	},
	logo: {
		display: 'flex',
		alignItems: 'center',
		border: 'solid white',
		borderWidth: '0px 0px 1px 0px',
		cursor: 'pointer',
		'& img': {
			width: 'auto',
			maxHeight: '50%',
			margin: '10px',
		},
		'& #name': {
			display: 'inline-block',
			margin: 'auto 0px auto 0px',
			fontFamily: 'NanumR',
			fontSize: '1.5rem',
			fontWeight: 'bolder',
		},
	},
	userinfo: {
		display: 'flex',
		justifyContent: 'center',
		flexDirection: 'column',
		alignItems: 'center',
		border: 'solid white',
		borderWidth: '0px 0px 1px 0px',
		paddingBottom: '0.5vh',
		'& #name': {
			display: 'inline-block',
			fontFamily: 'NanumR',
			fontSize: '1.25rem',
			fontWeight: 'bolder',
		},
	},
	menu: {
		border: 'solid white',
		borderWidth: '0px 0px 1px 0px',
		'& ul': {
			marginTop: '10px',
			'& li': {
				fontSize: '1rem',
				fontWeight: 'bolder',
				color: `${COLORS.SLATE_GREY}`,
				'& ul': {
					listStyle: 'none',
					paddingLeft: '0px',
					'& li': {
						fontSize: '1rem',
						fontWeight: 'normal',
						margin: '0px',
						cursor: 'pointer',
					},
				},
			},
		},
	},
	navigator: {
		display: 'grid',
		gridTemplateColumns: '3fr 2fr',
		backgroundColor: `${COLORS.WATER_BLUE}`,
	},
	form: {
		display: 'flex',
		width: '100%',
		height: '100%',
		justifyContent: 'center',
		alignItems: 'center',
		margin: 'auto',
		gap: '5%',
		'& input': {
			width: '70%',
			height: '55%',
		},
		'& Button': {
			border: 'solid 1px',
		},
	},
	table: {
		display: 'grid',
		gridTemplateRows: '50px 1fr',
		width: '95%',
		height: '80vh',
		margin: '1% auto',
		border: 'solid 2px',
		borderRadius: '10px 10px 0 10px',
		'& #title': {
			display: 'grid',
			gridTemplateColumns: '3fr 7fr 5fr 3fr 17px',
			border: 'solid',
			borderWidth: '0 0 2px 0',
			'& span': {
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'center',
				'& p': {
					fontSize: '1.15rem',
					fontWeight: 'bolder',
				},
			},
		},
		'& #classinfo': {
			overflow: 'scroll',
			overflowX: 'hidden',
			borderRadius: '0 0 0 10px',
		},
		'& ul': {
			padding: '0',
		},
		'& li': {
			border: 'solid',
			borderWidth: '0 0 2px 0',
		},
	},
	classInfo: {
		display: 'grid',
		gridTemplateColumns: '3fr 7fr 5fr 3fr',
		padding: '25px 0',
		backgroundColor: `${COLORS.LIGHT_GREY}`,
	},
	buttonLabel: {
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		alignItems: 'center',
		color: `${COLORS.CHARCHOAL_GREY}`,
		fontSize: 18,
		fontFamily: 'NanumB',
		fontWeight: 'bold',
		lineHeight: '21px',
	},
	infoButton: {
		borderWidth: 1,
		borderStyle: 'solid',
		borderColor: `${COLORS.CHARCHOAL_GREY}`,
		backgroundColor: `${COLORS.WATER_BLUE}`,
		borderRadius: '10px',
		margin: '0.5vh',
		width: '8vw',
	},
	deleteButton: {
		borderWidth: 1,
		borderStyle: 'solid',
		borderColor: `${COLORS.CHARCHOAL_GREY}`,
		backgroundColor: `${COLORS.PUMPKIN}`,
		borderRadius: '10px',
		margin: '0.5vh',
		width: '8vw',
	},
	buttonFont: {
		color: `${COLORS.WHITE}`,
		fontSize: '1vw',
	},
	blank: {
		display: 'flex',
		height: '40px',
	},
	logoutButton: {
		backgroundColor: `${COLORS.WATER_BLUE}`,
	},
	logoutButtonFont: {
		fontSize: '0.7vh',
		fontFamily: 'NanumB',
		fontWeight: 'bold',
		color: `${COLORS.WHITE}`,
	},
	logoutSection: {
		display: 'flex',
	},
}));

type iClassList = {
	class_code: string;
	class_name: string;
	class_country: string;
	reg_date: string;
};

const SERVER = basic.server;

const HeadAdminAccountManage: React.FC<any> = (props) => {
	const classes = useStyles();
	let history = useHistory();

	const { member, deleteMember } = props;
	const [cookies, setCookie, removeCookie] = useCookies();

	const [ClassList, setClassList] = useState<iClassList[]>([]);
	const [targetEmail, setTargetEmail] = useState<any | null>();

	const getApplicationList = () => {
		axios({
			method: 'GET',
			withCredentials: true,
			url: SERVER + v_headadmin.headadmin + v_headadmin.application_list,
		})
			.then((res) => {
				return res.data;
			})
			.then((data: any) => {
				console.log('data?', data);
				if (data.code == Values.SUCCESS_CODE) {
					setClassList(data.data);
				}
			});
	};

	const valueChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
		const { id, value } = e.target;
		if (id == 'targetEmail') setTargetEmail(value);
	};

	const searchControl = () => {
		if (targetEmail == '') getApplicationList();
		else searchApplication();
	};

	const searchApplication = () => {
		let url = new URL(SERVER + v_headadmin.headadmin + v_headadmin.search_application);
		let params = { email: targetEmail.toString() };
		url.search = new URLSearchParams(params).toString();
		axios({
			method: 'GET',
			withCredentials: true,
			url: url.toString(),
		})
			.then((res) => {
				return res.data;
			})
			.then((data: any) => {
				console.log('data?', data);
				if (data.code == Values.SUCCESS_CODE) {
					setClassList(data.data);
				}
			});
	};

	const moveMaterialList = () => {
		history.push('/headAdminMaterialList');
	};
	const moveProductList = () => {
		history.push('/headAdminLicenseList');
	};
	const moveClassList = () => {
		history.push('/headAdminClassList');
	};
	const moveClassManage = () => {
		history.push('/headAdminClassManage');
	};
	const moveMemberList = () => {
		history.push('/headAdminMemberList');
	};
	const moveAccountManage = () => {
		history.push('/headAdminAccountManage');
	};
	const moveCreateClass = () => {
		history.push('/headAdminCreateClass');
	};

	const logout = () => {
		removeCookie('access');
		deleteMember();
		history.push('/headadmin');
	};

	useEffect(() => {
		getApplicationList();
	}, []);

	return (
		<div className={classes.background}>
			<CssBaseline />
			<div className={classes.content}>
				<div className={classes.sidebar}>
					<div className={classes.logo} onClick={(e) => moveClassList()}>
						<img src="/images/p.webp"></img>
						<Typography id="name">플레이스타트업</Typography>
					</div>
					<div className={classes.userinfo}>
						<Typography id="name">{member.name}님, 환영합니다!</Typography>
						<div className={classes.logoutSection}>
							<Button onClick={logout} className={classes.logoutButton}>
								<Typography className={classes.logoutButtonFont}>로그아웃</Typography>
							</Button>
						</div>
					</div>
					<div className={classes.menu}>
						<ul>
							<li>
								품목 관리
								<ul>
									<li onClick={(e) => moveMaterialList()}>재료 목록</li>
									<li onClick={(e) => moveProductList()}>제품 목록</li>
								</ul>
							</li>
						</ul>
					</div>
					<div className={classes.menu}>
						<ul>
							<li>
								교육 관리
								<ul>
									<li onClick={(e) => moveClassList()}>교육 목록</li>
									<li onClick={(e) => moveClassManage()}>교육 관리 목록</li>
								</ul>
							</li>
						</ul>
					</div>
					<div className={classes.menu}>
						<ul>
							<li>
								회원 관리
								<ul>
									<li onClick={(e) => moveMemberList()}>회원 목록</li>
									<li onClick={(e) => moveAccountManage()}>기업 계정 관리</li>
								</ul>
							</li>
						</ul>
					</div>
				</div>
				<div className={classes.mainPage}>
					<div className={classes.navigator}>
						<div className={classes.title}>기업 계정 관리</div>
						<div className={classes.form}>
							<input type="text" placeholder="검색하려는 이메일을 입력해주세요." id="targetEmail" onChange={valueChangeHandler} />
							<Button onClick={searchControl}>
								<Typography>검색</Typography>
							</Button>
						</div>
					</div>
					<div>
						<div className={classes.table}>
							<div id="title">
								<span>
									<Typography>이름</Typography>
								</span>
								<span>
									<Typography>이메일</Typography>
								</span>
								<span>
									<Typography>기업명</Typography>
								</span>
								<span>
									<Typography>처리</Typography>
								</span>
							</div>
							<List id="classinfo">
								{ClassList != null &&
									ClassList.map((item: any, index: number) => {
										return <AppListItem index={index} name={item.subAdmin_name} email={item.subAdmin_email} company={item.subAdmin_company_name} />;
									})}
								<div className={classes.blank}></div>
							</List>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

const AppListItem: React.FC<any> = (props) => {
	const [dialogApproveState, setDialogApproveState] = useState(false);
	const [dialogDeclineState, setDialogDeclineState] = useState(false);
	const { enqueueSnackbar, closeSnackbar } = useSnackbar();

	const classes = useStyles();
	let history = useHistory();
	const { index, name, email, company, getMember } = props;

	const handleApproveClose = () => {
		setDialogApproveState(false);
	};

	const handleApproveOpen = () => {
		console.log('in handleOpen');
		console.log(email);
		if (!dialogApproveState) {
			setDialogApproveState(true);
		}
	};

	const handleDeclineClose = () => {
		setDialogDeclineState(false);
	};

	const handleDeclineOpen = () => {
		console.log('in handleOpen');
		if (!dialogDeclineState) {
			setDialogDeclineState(true);
		}
	};

	const applicationUpdate = () => {
		console.log('hello');
		let url = new URL(basic.server + v_headadmin.headadmin + v_headadmin.application_update);
		axios({
			method: 'POST',
			withCredentials: true,
			url: url.toString(),
			data: {
				subadmin_email: email,
			},
		})
			.then((res) => res.data)
			.then((data: any) => {
				console.log(data);
				if (data.code == Values.SUCCESS_CODE) {
					enqueueSnackbar('계정 승인이 완료되었습니다.', { variant: 'success', autoHideDuration: SNACKBAR_TIME });
				} else if (data.code == Values.FAIL_CODE) {
					if (data.msg) enqueueSnackbar(data.msg, { variant: 'warning', autoHideDuration: SNACKBAR_TIME });
					else enqueueSnackbar('계정 승인 요청에 실패했습니다.', { variant: 'warning', autoHideDuration: SNACKBAR_TIME });
				} else {
					if (data.msg) enqueueSnackbar(data.msg, { variant: 'error' });
					else enqueueSnackbar('계정 승인 과정에서 오류가 발생했습니다.', { variant: 'error', autoHideDuration: SNACKBAR_TIME });
				}
			})
			.then(() => {
				window.location.replace('/headAdminAccountManage');
			});
		handleApproveClose();
	};

	const applicationDelete = () => {
		let url = new URL(basic.server + v_headadmin.headadmin + v_headadmin.application_delete);
		axios({
			method: 'POST',
			withCredentials: true,
			url: url.toString(),
			data: {
				subadmin_email: email,
			},
		})
			.then((res) => res.data)
			.then((data: any) => {
				console.log(data);
				if (data.code == Values.SUCCESS_CODE) {
					enqueueSnackbar('승인을 거부했습니다.', { variant: 'success', autoHideDuration: SNACKBAR_TIME });
					//props.setLicenseStatus(e, 'complete', data.regDate, data.now)
				} else if (data.code == Values.FAIL_CODE) {
					if (data.msg) enqueueSnackbar(data.msg, { variant: 'warning', autoHideDuration: SNACKBAR_TIME });
					else enqueueSnackbar('계정 거절에 실패했습니다.', { variant: 'warning', autoHideDuration: SNACKBAR_TIME });
				} else {
					if (data.msg) enqueueSnackbar(data.msg, { variant: 'error' });
					else enqueueSnackbar('계정 거절 과정에서 오류가 발생했습니다.', { variant: 'error', autoHideDuration: SNACKBAR_TIME });
				}
			})
			.then(() => {
				window.location.replace('/headAdminAccountManage');
			});
		handleDeclineClose();
	};

	return (
		<ListItem id={index} className={classes.classInfo}>
			<Box className={classes.buttonLabel}>{name}</Box>
			<Box className={classes.buttonLabel}>{email}</Box>
			<Box className={classes.buttonLabel}>{company}</Box>
			<Box className={classes.buttonLabel}>
				<Button className={classes.infoButton} onClick={handleApproveOpen}>
					<Typography className={classes.buttonFont}>승인</Typography>
				</Button>
				<DialogApprove
					open={dialogApproveState}
					handleClose={handleApproveClose}
					title={'계정을 승인하시겠습니까?'}
					context={`계정 명 : ${name}`}
					yesConfirm={applicationUpdate}
					noConfirm={handleApproveClose}
				/>
				<Button className={classes.deleteButton} onClick={handleDeclineOpen}>
					<Typography className={classes.buttonFont}>거절</Typography>
				</Button>
				<DialogDeleteClass
					open={dialogDeclineState}
					handleClose={handleDeclineClose}
					title={'계정을 거절하시겠습니까?'}
					context={`계정 명 : ${name}`}
					yesConfirm={applicationDelete}
					noConfirm={handleDeclineClose}
				/>
			</Box>
		</ListItem>
	);
};

export default HeadAdminAccountManage;
